export default "__VITE_ASSET__agxHX5BF__"